// extracted by mini-css-extract-plugin
export default {"cycleWrapper":"CiklusiKomponenta_cycleWrapper__vF6RR"};